module.exports = __webpack_public_path__ + "static/celo-f0690d2569d5e8f5983b3900c52af3b1.png";